import { useState } from "react";
import "../../styles/studyTableSetting.css";

const COLOR_OPTIONS = [
  "NONE",
  "Red",
  "Orange",
  "Yellow",
  "Green",
  "Blue",
  "Purple",
  "Pink",
  "Gray",
  "White",
];
const COLOR_FIELDS = [
  { key: "notReported",      label: "Color of studies which not reported"      },
  { key: "urgentStudies",    label: "Color of urgent studies"                  },
  { key: "assignedElse",     label: "Color of assigned to someone else studies"},
  { key: "lockedStudies",    label: "Color of locked studies"                  },
  { key: "signedOffStudies", label: "Color of signed off studies"              },
];
export default function StudyTableSetting({ isOpen, onClose, onSubmit }) {
  const [radiantPath, setRadiantPath] = useState("");
  const [colors, setColors] = useState({
    notReported:      "NONE",
    urgentStudies:    "NONE",
    assignedElse:     "NONE",
    lockedStudies:    "NONE",
    signedOffStudies: "NONE",
  });
  if (!isOpen) return null;
  function handleColorChange(key, value) {
    setColors((prev) => ({ ...prev, [key]: value }));
  }
  function handleSubmit() {
    onSubmit?.({ radiantPath, colors });
    onClose?.();
  }
  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose?.();
  }
  return (
    <div className="sts-backdrop" onMouseDown={handleBackdrop}>
      <div className="sts-modal">
        {/* Title */}
        <h2 className="sts-title">Study Table setting</h2>
        {/* Subtitle */}
        <p className="sts-subtitle">Setting to customize study table interface</p>
        {/* Scrollable content */}
        <div className="sts-content">
          {/* Path to download folder */}
          <div className="sts-field">
            <label className="sts-field-label">
              Path to download folder to open cases in Radiant
            </label>
            <input
              type="text"
              className="sts-input"
              placeholder="for example: C:\Users\John\Downloads"
              value={radiantPath}
              onChange={(e) => setRadiantPath(e.target.value)}
            />
            <span className="sts-input-hint">
              for example: C:\Users\John\Downloads
            </span>
          </div>
          {/* Color fields */}
          {COLOR_FIELDS.map(({ key, label }) => (
            <div key={key} className="sts-field">
              <label className="sts-field-label">{label}</label>
              <select
                className="sts-select"
                value={colors[key]}
                onChange={(e) => handleColorChange(key, e.target.value)}
              >
                {COLOR_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>
          ))}
        </div>
        {/* Submit */}
        <button className="sts-submit-btn" onClick={handleSubmit}>
          SUBMIT
        </button>
        {/* Close */}
        <div className="sts-close-row">
          <button className="sts-close-btn" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}